"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _DepositFormComponent = _interopRequireDefault(require("./DepositFormComponent"));
var _depositActions = require("../../redux/actions/depositActions");
var _modalActions = require("../../redux/actions/modalActions");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var formName = 'createDeposit';
var mapStateToProps = function mapStateToProps(state, _ref) {
  var product = _ref.product;
  return {
    deposit: state.deposit,
    isDasc: product.Product === 'DASC' || product.Product === 'DAS'
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectDepositProduct: function selectDepositProduct(productId) {
      return dispatch((0, _depositActions.fetchAllProductDepositTemplates)(productId));
    },
    selectDepositTemplate: function selectDepositTemplate(productId, templateType) {
      return dispatch((0, _depositActions.fetchProductDepositTemplate)(productId, templateType));
    },
    changeFieldValue: function changeFieldValue(field, value) {
      return dispatch((0, _reduxForm.change)(formName, field, value));
    }
  };
};
var DepositFormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DepositFormComponent["default"]);
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: formName,
  onSubmit: function onSubmit(payload, dispatch, _ref2) {
    var _ref2$product = _ref2.product,
      ProductId = _ref2$product.ProductId,
      Product = _ref2$product.Product;
    dispatch((0, _depositActions.createDepositTicket)(_objectSpread(_objectSpread({}, payload), {}, {
      ProductId: ProductId
    })));
    if (_config["default"].Deposit.showDepositIdModal) {
      dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.DEPOSIT_REFERENCE_ID, {
        ProductSymbol: Product
      }));
    }
  }
})(DepositFormContainer);